import {BaseObject} from './BaseObject';

export const DOCUMENT_TYPE = {
    'INVOICE': 'invoice',
    'RECEIVED_PAYMENT': 'received-payment',
    'CREDIT_NOTE': 'credit-note',
    'PREFORMA': 'proforma',
    'RECEIVABLE': 'receivable',
};
export class DocumentType extends BaseObject {

    id: number;
    name: string;
    slug: string;
    color: string;
    numberPrefix: string;

    nextNumber: string;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/DocumentType.ts